<template>
  <div>
    <TeamLeader />
    <PaySign />
  </div>
</template>
<script>
import TeamLeader from '../staff/TeamLeader'
import PaySign from './PaySign'
export default {
  components: {
    TeamLeader,
    PaySign
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/heaveCompetition/PayJoin.vue